import { Button, Dialog, TextField } from "@mui/material";
import axios from "axios";
import { useEffect, useState } from "react";
import { useSnackbar } from "notistack";
import { ProjectConfig } from "Global";
import { ApiRequest } from "GlobalFunctions";

export default function EventsEditor(props: any) {
  const { setLoading, openEditor, setOpenEditor, event_id, loadList } = props;
  const { enqueueSnackbar } = useSnackbar();

  const defaultValues = {
    event_id: event_id ? event_id : "null",
    event: "",
  };

  const [formValues, setFormValues] = useState(defaultValues);

  useEffect(() => {
    if (event_id) {
      axios
        .get(`${ProjectConfig.api_url}/orders-concepts/details_events`, {
          params: { event_id },
        })
        .then((response) => {
          setFormValues(response.data.data);
        })
        .catch((err) => {
          console.log(err.response);
        });
    } else {
      setFormValues(defaultValues);
    }
  }, [event_id]);

  const handleInputChange = (e: { target: { name: any; value: any } }) => {
    const { name, value } = e.target;
    setFormValues({ ...formValues, [name]: value });
  };

  const handleSubmit = async () => {
    setLoading(true);
    const body = new FormData();
    body.append("formValues", JSON.stringify(formValues));

    await ApiRequest({
      url: "/orders-concepts/addedit_events",
      method: "post",
      headers: {
        ltkn: localStorage.getItem("ltkn"),
      },
      body: body,
      setResponse: (response: any) => {
        if (response.status === "success") {
          enqueueSnackbar("Evento guardado con éxito", { variant: "success" });
          setOpenEditor(false);
          loadList();
        } else {
          enqueueSnackbar(response.message, { variant: "error" });
        }
        setLoading(false);
      },
    });
  };

  return (
    <Dialog open={openEditor} onClose={() => setOpenEditor(false)}>
      <div className="DialogContainer" style={{ maxWidth: "502px" }}>
        <div className="ModuleWrapper">
          <div className="boxContainerHeader">
            <div className="boxContainerTitle">
              <h2 className="h2_title">Evento</h2>
              <span className="h2_subtitle">{event_id ? "Editar" : "Crear"}</span>
            </div>
          </div>

          <div className="input_group">
            <TextField
              id="event"
              name="event"
              label="Evento"
              type="text"
              required
              fullWidth
              value={formValues.event}
              onChange={handleInputChange}
            />
          </div>

          <div className="dialogButtons">
            <Button onClick={() => setOpenEditor(false)} variant="outlined">
              Cancelar
            </Button>
            <Button onClick={handleSubmit} variant="contained">
              Guardar
            </Button>
          </div>
        </div>
      </div>
    </Dialog>
  );
}
